import { FC } from 'react'

import {
  Text,
  IconPlus,
  Button,
  MultiSelectControl,
  Option,
  Primary13Regular,
  RedRed60,
  Flex
} from '@sequencehq/core-components'
import { ValidationError } from '@sequencehq/utils'

export const ApproverMultiSelectControl: FC<{
  options: Option[]
  initialValues: string[]
  onChange: (emails: string[]) => void
  isDisabled: boolean
  validationErrors?: Pick<ValidationError, 'message'>[]
  /** When true, the dropdown opens as soon as the control mounts. */
  initiallyOpen?: boolean
  'data-testid'?: string
}> = ({
  options,
  initialValues,
  onChange,
  isDisabled,
  validationErrors,
  initiallyOpen,
  'data-testid': dataTestId
}) => {
  return (
    <Flex alignItems="center" gap="8px">
      <MultiSelectControl
        data-testid={dataTestId}
        options={options}
        initialValues={initialValues}
        onChange={onChange}
        initiallyOpen={initiallyOpen}
        trigger={
          <Button
            data-testid={dataTestId ? `${dataTestId}.button` : undefined}
            variant="secondary"
            leadingIcon={<IconPlus color="inherit" />}
            disabled={isDisabled}
          >
            Add approver
          </Button>
        }
      />
      {validationErrors?.at(0) && (
        <Text {...Primary13Regular} color={RedRed60}>
          {validationErrors.at(0)?.message}
        </Text>
      )}
    </Flex>
  )
}
